<div *ngIf="{ menuData: menuData$ | async,
  declinedReasons: declinedReasonsDropdown$ | async,
    currentEmployee: authenticatedEmployee$ | async,
    quoteLines: serviceLaneFacade.quoteLines$ | async,
     hyundaiServices: hyundaiMenuNgrxFacade.selectHyundaiServices$ | async,
     acceptedServices: hyundaiMenuNgrxFacade.selectAcceptedServices$ | async,
     declinedServices: hyundaiMenuNgrxFacade.selectDeclinedServices$ | async,
     disableRemoveServiceButton: this.serviceLaneFacade.disableHyundaiMenuRemoveServiceButton$ | async,
     disableAddServiceButton: this.serviceLaneFacade.disableHyundaiMenuAddServiceButton$ | async,
     selectedAppointmentCases: this.serviceLaneFacade.getSelectedAppointmentCasesWithServiceGroupAndRate$ | async,
     selectedAppointmentDeclinedOperations: this.serviceLaneFacade.serviceAppointmentDeclinedOperations$ | async}
    as data">
  <div *ngIf="data.menuData?.hyundaiResponse; else loading">
    <div *ngIf="!data.menuData?.hyundaiResponse.error; else hyundaiMenuError" class="flex flex-col">
      <div class="flex flex-row items-center justify-between">
        <span class="flex-grow flex flex-col">
          <span class="text-sm font-lg text-grey-900" id="availability-label">Summary View</span>
          <span class="text-sm text-grey-500" id="availability-description">Toggle off to view the full schedule.</span>
        </span>
        <button (click)="showFullSchedule = !showFullSchedule" type="button"
          [ngClass]="{'bg-quorum-blue': showFullSchedule, 'bg-grey-200': !showFullSchedule}"
          class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-quorum-blue-comp"
          role="switch" aria-checked="false" aria-labelledby="availability-label"
          aria-describedby="availability-description">
          <span aria-hidden="true" [ngClass]="{'translate-x-5': showFullSchedule, 'translate-x-0': !showFullSchedule}"
            class="pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"></span>
        </button>
      </div>
      <div *ngIf="!showFullSchedule; else fullSchedule"
        class="flex flex-row border border-solid border-grey-300 divide-x rounded-lg w-full mt-5 h-auto">
        <div id="previousService" class="flex flex-col w-4/12 pt-4 px-2 divide-y divide-grey-300">
          <span class="flex place-content-center font-medium text-sm pb-3">Previous Service</span>
          <div class="flex flex-col pt-3">
            <span
              class="flex pb-2 font-medium text-sm place-content-center">{{data?.menuData?.hyundaiResponse?.PreviousServiceOdometer
              |
              unitOfMeasure | async }}
              Service</span>
            <span class="text-xs text-grey-400 pb-5">Includes below services:</span>
            <div *ngFor="let service of data.menuData?.hyundaiResponse?.PreviousService; let i = index " class="pb-3">
              <div class="flex flex-col">
                <div class="flex flex-row place-content-between">
                  <span class="flex w-3/4">{{service.Name}}</span>
                  <span class="flex w-1/4 justify-end pr-0.5"
                    *ngIf="service?.dmsOpCodeRecord?.serviceGroupRate?.rate; else noPrice">{{service?.dmsOpCodeRecord?.serviceGroupRate?.rate
                    |
                    currency}}</span>
                  <ng-template #noPrice>
                    <span class="flex w-1/4 justify-end pr-0.5">N/A</span>
                  </ng-template>
                </div>

                <div class="h-4">
                  <span *ngIf="acceptedAsALineItem(service?.dmsOpCodeRecord, data.selectedAppointmentCases)"
                    class="text-green-500 text-xs flex">Accepted on current transaction.</span>
                  <span
                    *ngIf="declinedOnAppointment(service?.dmsOpCodeRecord, data.selectedAppointmentDeclinedOperations)"
                    class="text-red-500 text-xs flex">Declined on current transaction.</span>
                  <span *ngIf="alreadyProcessedOnWorkOrder(service?.dmsOpCodeRecord, data.acceptedServices)"
                    class="text-green-500 text-xs flex">Accepted on current transaction.</span>
                </div>

                <div class="relative py-2">
                  <div class="absolute inset-0 flex items-center" aria-hidden="true">
                    <div class="w-full border-t border-grey-300"></div>
                  </div>
                  <div class="relative flex items-center justify-between" value="false" #serviceDetailsToggle>
                    <span type="button" [ngClass]="{'invisible': service.ChildServiceDetails.length == 0 }"
                      (click)="serviceDetailsToggle.value = !serviceDetailsToggle.value"
                      class="inline-flex items-center shadow-sm px-4 py-1.5 border border-grey-300 text-sm leading-5 font-medium rounded-full text-grey-700 bg-white">
                      <svg *ngIf="!serviceDetailsToggle.value; else minus" class="-ml-1.5 mr-1 h-5 w-5 text-grey-400"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd"
                          d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                          clip-rule="evenodd" />
                      </svg>
                      <ng-template #minus>
                        <svg class="-ml-1.5 mr-1 h-5 w-5 text-grey-400" xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20" fill="currentColor">
                          <path fill-rule="evenodd" d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z"
                            clip-rule="evenodd" />
                        </svg>
                      </ng-template>
                      <span>Details</span>
                    </span>
                    <div [ngClass]="{'invisible': !service?.dmsOpCodeRecord?.serviceGroupRate }">
                      <button type="button" (click)="declineService(service)"
                        [disabled]="data.disableAddServiceButton === true || acceptedAsALineItem(service?.dmsOpCodeRecord, data.selectedAppointmentCases) || declinedOnAppointment(service?.dmsOpCodeRecord, data.selectedAppointmentDeclinedOperations)"
                        *ngIf="!checkServiceGroupStatus('declined', service?.dmsOpCodeRecord, data.hyundaiServices); else declined"
                        [ngClass]="[checkServiceGroupStatus('accepted', service?.dmsOpCodeRecord, data.hyundaiServices) ? 'invisible': '', data.disableAddServiceButton === true || acceptedAsALineItem(service?.dmsOpCodeRecord, data.selectedAppointmentCases) || declinedOnAppointment(service?.dmsOpCodeRecord, data.selectedAppointmentDeclinedOperations) ? 'bg-grey-300' : 'bg-white']"
                        class="inline-flex items-center shadow-sm px-2 py-1.5 border border-grey-300 text-sm leading-5 font-medium rounded-full text-grey-700 bg-white">
                        <svg class="h-5 w-5 text-grey-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                          fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd"
                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                            clip-rule="evenodd" />
                        </svg>
                      </button>

                      <ng-template #declined>
                        <button type="button" [disabled]="data.disableRemoveServiceButton === true"
                          [ngClass]="data.disableRemoveServiceButton === true ? 'bg-grey-300' : 'bg-red-500'"
                          (click)="removeDeclinedService(service)"
                          class="inline-flex items-center shadow-sm px-2 py-1.5 border border-grey-300 text-sm ml-1 leading-5 font-medium rounded-full text-grey-700">
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4" />
                          </svg>
                        </button>
                      </ng-template>

                      <button type="button" (click)="acceptService(service, data.menuData.vehicle)"
                        [disabled]="data.disableAddServiceButton === true || acceptedAsALineItem(service?.dmsOpCodeRecord, data.selectedAppointmentCases) || declinedOnAppointment(service?.dmsOpCodeRecord, data.selectedAppointmentDeclinedOperations)"
                        [ngClass]="[checkServiceGroupStatus('declined', service?.dmsOpCodeRecord, data.hyundaiServices) ? 'invisible': '', data.disableAddServiceButton === true || acceptedAsALineItem(service?.dmsOpCodeRecord, data.selectedAppointmentCases) || declinedOnAppointment(service?.dmsOpCodeRecord, data.selectedAppointmentDeclinedOperations) ? 'bg-grey-300' : 'bg-white']"
                        *ngIf="!checkServiceGroupStatus('accepted', service?.dmsOpCodeRecord, data.hyundaiServices); else accepted"
                        class="inline-flex items-center shadow-sm px-2 py-1.5 border border-grey-300 text-sm ml-1 leading-5 font-medium rounded-full text-grey-700 bg-white">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-grey-400" fill="none"
                          viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                      </button>

                      <ng-template #accepted>
                        <button type="button"
                          [disabled]="data.disableRemoveServiceButton === true || alreadyProcessedOnWorkOrder(service?.dmsOpCodeRecord, data.acceptedServices)"
                          [ngClass]="data.disableRemoveServiceButton === true || alreadyProcessedOnWorkOrder(service?.dmsOpCodeRecord, data.acceptedServices) ? 'bg-grey-300' : 'bg-green-500'"
                          (click)="removeAcceptedService(service)"
                          class="inline-flex items-center shadow-sm px-2 py-1.5 border border-grey-300 text-sm ml-1 leading-5 font-medium rounded-full text-grey-700">
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4" />
                          </svg>
                        </button>
                      </ng-template>

                    </div>
                  </div>
                </div>

                <div *ngIf="checkServiceGroupStatus('declined', service?.dmsOpCodeRecord, data.hyundaiServices)"
                  class="flex flex-col place-content-end px-2">
                  <span class="text-grey-600">Declined reason:</span>
                  <mat-form-field>
                    <mat-select
                      [(value)]="data.declinedServices.entities[service?.dmsOpCodeRecord.workOrderLocationOpCode] ? data.declinedServices.entities[service?.dmsOpCodeRecord.workOrderLocationOpCode].declinedReasonId : previousDeclinedReason"
                      (selectionChange)="declinedReasonSelected(service, $event.value)">
                      <mat-option [value]="previousDeclinedReason.id"
                        *ngFor="let previousDeclinedReason of data.declinedReasons | filterBy: ['rooftopId']: data.currentEmployee.rooftopId | orderBy: ['reason']">
                        {{previousDeclinedReason.reason}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div *ngIf="serviceDetailsToggle.value" class="flex flex-col py-1 px-3">
                  <ul class="list-disc leading-relaxed pl-1">
                    <li *ngFor="let childService of service.ChildServiceDetails | orderBy: ['DisplayOrder']"
                      class="text-grey-500">{{childService.Name}}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div id="currentService" class="flex flex-col w-4/12 pt-4 px-2 bg-grey-200">
          <span class="flex place-content-center font-medium text-base pb-2">Current Service</span>
          <div class="flex flex-col pt-3">
            <span
              class="flex pb-1 font-medium text-base place-content-center">{{data.menuData?.hyundaiResponse?.CurrentServiceOdometer
              |
              unitOfMeasure | async }}
              Service</span>
            <span class="text-xs text-grey-400 pb-5">Includes below services:</span>
            <div *ngFor="let service of data.menuData?.hyundaiResponse?.CurrentService; let i = index " class="pb-3">

              <div class="flex flex-col">
                <div class="flex flex-row place-content-between">
                  <span class="flex w-3/4">{{service.Name}}</span>
                  <span class="flex w-1/4 justify-end pr-0.5"
                    *ngIf="service?.dmsOpCodeRecord?.serviceGroupRate?.rate; else noPrice">{{service?.dmsOpCodeRecord?.serviceGroupRate?.rate
                    |
                    currency}}</span>
                  <ng-template #noPrice>
                    <span class="flex w-1/4 justify-end pr-0.5">N/A</span>
                  </ng-template>
                </div>

                <div class="h-4">
                  <span *ngIf="acceptedAsALineItem(service?.dmsOpCodeRecord, data.selectedAppointmentCases)"
                    class="text-green-500 text-xs flex">Accepted on current transaction.</span>
                  <span
                    *ngIf="declinedOnAppointment(service?.dmsOpCodeRecord, data.selectedAppointmentDeclinedOperations)"
                    class="text-red-500 text-xs flex">Declined on current transaction.</span>
                  <span *ngIf="alreadyProcessedOnWorkOrder(service?.dmsOpCodeRecord, data.acceptedServices)"
                    class="text-green-500 text-xs flex">Accepted on current transaction.</span>
                </div>

                <div class="relative py-2">
                  <div class="absolute inset-0 flex items-center" aria-hidden="true">
                    <div class="w-full border-t border-grey-300"></div>
                  </div>
                  <div class="relative flex items-center justify-between" value="false" #serviceDetailsToggle>
                    <span type="button" [ngClass]="{'invisible': service.ChildServiceDetails.length == 0 }"
                      (click)="serviceDetailsToggle.value = !serviceDetailsToggle.value"
                      class="inline-flex items-center shadow-sm px-4 py-1.5 border border-grey-300 text-sm leading-5 font-medium rounded-full text-grey-700 bg-white">
                      <svg *ngIf="!serviceDetailsToggle.value; else minus" class="-ml-1.5 mr-1 h-5 w-5 text-grey-400"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd"
                          d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                          clip-rule="evenodd" />
                      </svg>
                      <ng-template #minus>
                        <svg class="-ml-1.5 mr-1 h-5 w-5 text-grey-400" xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20" fill="currentColor">
                          <path fill-rule="evenodd" d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z"
                            clip-rule="evenodd" />
                        </svg>
                      </ng-template>
                      <span>Details</span>
                    </span>
                    <div [ngClass]="{'invisible': !service?.dmsOpCodeRecord?.serviceGroupRate }">
                      <button type="button" (click)="declineService(service)"
                        [disabled]="data.disableAddServiceButton === true || acceptedAsALineItem(service?.dmsOpCodeRecord, data.selectedAppointmentCases) || declinedOnAppointment(service?.dmsOpCodeRecord, data.selectedAppointmentDeclinedOperations)"
                        *ngIf="!checkServiceGroupStatus('declined', service?.dmsOpCodeRecord, data.hyundaiServices); else declined"
                        [ngClass]="[checkServiceGroupStatus('accepted', service?.dmsOpCodeRecord, data.hyundaiServices) ? 'invisible': '', data.disableAddServiceButton === true || acceptedAsALineItem(service?.dmsOpCodeRecord, data.selectedAppointmentCases) || declinedOnAppointment(service?.dmsOpCodeRecord, data.selectedAppointmentDeclinedOperations)? 'bg-grey-300' : 'bg-white']"
                        class="inline-flex items-center shadow-sm px-2 py-1.5 border border-grey-300 text-sm leading-5 font-medium rounded-full text-grey-700 bg-white">
                        <svg class="h-5 w-5 text-grey-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                          fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd"
                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                            clip-rule="evenodd" />
                        </svg>
                      </button>

                      <ng-template #declined>
                        <button type="button" [disabled]="data.disableRemoveServiceButton === true"
                          [ngClass]="data.disableRemoveServiceButton === true ? 'bg-grey-300' : 'bg-red-500'"
                          (click)="removeDeclinedService(service)"
                          class="inline-flex items-center shadow-sm px-2 py-1.5 border border-grey-300 text-sm ml-1 leading-5 font-medium rounded-full text-grey-700">
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4" />
                          </svg>
                        </button>
                      </ng-template>

                      <button type="button" (click)="acceptService(service, data.menuData.vehicle)"
                        [disabled]="data.disableAddServiceButton === true || acceptedAsALineItem(service?.dmsOpCodeRecord, data.selectedAppointmentCases) || declinedOnAppointment(service?.dmsOpCodeRecord, data.selectedAppointmentDeclinedOperations)"
                        [ngClass]="[checkServiceGroupStatus('declined', service?.dmsOpCodeRecord, data.hyundaiServices) ? 'invisible': '', data.disableAddServiceButton === true || acceptedAsALineItem(service?.dmsOpCodeRecord, data.selectedAppointmentCases) || declinedOnAppointment(service?.dmsOpCodeRecord, data.selectedAppointmentDeclinedOperations) ? 'bg-grey-300' : 'bg-white']"
                        *ngIf="!checkServiceGroupStatus('accepted', service?.dmsOpCodeRecord, data.hyundaiServices); else accepted"
                        class="inline-flex items-center shadow-sm px-2 py-1.5 border border-grey-300 text-sm ml-1 leading-5 font-medium rounded-full text-grey-700 bg-white">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-grey-400" fill="none"
                          viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                      </button>

                      <ng-template #accepted>
                        <button type="button"
                          [disabled]="data.disableRemoveServiceButton === true || alreadyProcessedOnWorkOrder(service?.dmsOpCodeRecord, data.acceptedServices)"
                          [ngClass]="data.disableRemoveServiceButton === true || alreadyProcessedOnWorkOrder(service?.dmsOpCodeRecord, data.acceptedServices) ? 'bg-grey-300' : 'bg-green-500'"
                          (click)="removeAcceptedService(service)"
                          class="inline-flex items-center shadow-sm px-2 py-1.5 border border-grey-300 text-sm ml-1 leading-5 font-medium rounded-full text-grey-700">
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4" />
                          </svg>
                        </button>
                      </ng-template>

                    </div>
                  </div>
                </div>
                <div *ngIf="checkServiceGroupStatus('declined', service?.dmsOpCodeRecord, data.hyundaiServices)"
                  class="flex flex-col place-content-end px-2">
                  <span class="text-grey-600">Declined reason:</span>
                  <mat-form-field>
                    <mat-select
                      [(value)]="data.declinedServices.entities[service?.dmsOpCodeRecord.workOrderLocationOpCode] ? data.declinedServices.entities[service?.dmsOpCodeRecord.workOrderLocationOpCode].declinedReasonId : currentDefaultDeclinedReason"
                      (selectionChange)="declinedReasonSelected(service, $event.value)">
                      <mat-option [value]="currentDeclinedReason.id"
                        *ngFor="let currentDeclinedReason of data.declinedReasons | filterBy: ['rooftopId']: data.currentEmployee.rooftopId | orderBy: ['reason']">
                        {{currentDeclinedReason.reason}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div *ngIf="serviceDetailsToggle.value" class="flex flex-col py-1 px-3">
                  <ul class="list-disc leading-relaxed pl-1">
                    <li *ngFor="let childService of service.ChildServiceDetails | orderBy: ['DisplayOrder']"
                      class="text-grey-500">{{childService.Name}}</li>
                  </ul>
                </div>

              </div>
            </div>
          </div>
        </div>


        <div id="nextService" class="flex flex-col w-4/12 pt-4 px-2 divide-y divide-grey-300">
          <span class="flex place-content-center font-medium text-sm pb-3">Next Service</span>
          <div class="flex flex-col pt-3">
            <span
              class="flex pb-2 font-medium text-sm place-content-center">{{data.menuData?.hyundaiResponse?.NextServiceOdometer
              |
              unitOfMeasure | async }}
              Service</span>
            <span class="text-xs text-grey-400 pb-5">Includes below services:</span>
            <div *ngFor="let service of data.menuData?.hyundaiResponse?.NextService; let i = index " class="pb-3">
              <div class="flex flex-col">
                <div class="flex flex-row place-content-between">
                  <span class="flex w-3/4">{{service.Name}}</span>
                  <span class="flex w-1/4 justify-end pr-0.5"
                    *ngIf="service?.dmsOpCodeRecord?.serviceGroupRate?.rate; else noPrice">{{service?.dmsOpCodeRecord?.serviceGroupRate?.rate
                    |
                    currency}}</span>
                  <ng-template #noPrice>
                    <span class="flex w-1/4 justify-end pr-0.5">N/A</span>
                  </ng-template>
                </div>

                <div class="h-4">
                  <span *ngIf="acceptedAsALineItem(service?.dmsOpCodeRecord, data.selectedAppointmentCases)"
                    class="text-green-500 text-xs flex">Accepted on current transaction.</span>
                  <span
                    *ngIf="declinedOnAppointment(service?.dmsOpCodeRecord, data.selectedAppointmentDeclinedOperations)"
                    class="text-red-500 text-xs flex">Declined on current transaction.</span>
                  <span *ngIf="alreadyProcessedOnWorkOrder(service?.dmsOpCodeRecord, data.acceptedServices)"
                    class="text-green-500 text-xs flex">Accepted on current transaction.</span>
                </div>

                <div class="relative py-2">
                  <div class="absolute inset-0 flex items-center" aria-hidden="true">
                    <div class="w-full border-t border-grey-300"></div>
                  </div>
                  <div class="relative flex items-center justify-between" value="false" #serviceDetailsToggle>
                    <span type="button" [ngClass]="{'invisible': service.ChildServiceDetails.length == 0 }"
                      (click)="serviceDetailsToggle.value = !serviceDetailsToggle.value"
                      class="inline-flex items-center shadow-sm px-4 py-1.5 border border-grey-300 text-sm leading-5 font-medium rounded-full text-grey-700 bg-white">
                      <svg *ngIf="!serviceDetailsToggle.value; else minus" class="-ml-1.5 mr-1 h-5 w-5 text-grey-400"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd"
                          d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                          clip-rule="evenodd" />
                      </svg>
                      <ng-template #minus>
                        <svg class="-ml-1.5 mr-1 h-5 w-5 text-grey-400" xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20" fill="currentColor">
                          <path fill-rule="evenodd" d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z"
                            clip-rule="evenodd" />
                        </svg>
                      </ng-template>
                      <span>Details</span>
                    </span>
                    <div [ngClass]="{'invisible': !service?.dmsOpCodeRecord?.serviceGroupRate }">
                      <button type="button" (click)="declineService(service)"
                        [disabled]="data.disableAddServiceButton === true || acceptedAsALineItem(service?.dmsOpCodeRecord, data.selectedAppointmentCases) || declinedOnAppointment(service?.dmsOpCodeRecord, data.selectedAppointmentDeclinedOperations)"
                        *ngIf="!checkServiceGroupStatus('declined', service?.dmsOpCodeRecord, data.hyundaiServices); else declined"
                        [ngClass]="[checkServiceGroupStatus('accepted', service?.dmsOpCodeRecord, data.hyundaiServices) ? 'invisible': '', data.disableAddServiceButton === true || acceptedAsALineItem(service?.dmsOpCodeRecord, data.selectedAppointmentCases) || declinedOnAppointment(service?.dmsOpCodeRecord, data.selectedAppointmentDeclinedOperations) ? 'bg-grey-300' : 'bg-white']"
                        class="inline-flex items-center shadow-sm px-2 py-1.5 border border-grey-300 text-sm leading-5 font-medium rounded-full text-grey-700 bg-white">
                        <svg class="h-5 w-5 text-grey-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                          fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd"
                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                            clip-rule="evenodd" />
                        </svg>
                      </button>

                      <ng-template #declined>
                        <button type="button" [disabled]="data.disableRemoveServiceButton === true"
                          [ngClass]="data.disableRemoveServiceButton === true ? 'bg-grey-300' : 'bg-red-500'"
                          (click)="removeDeclinedService(service)"
                          class="inline-flex items-center shadow-sm px-2 py-1.5 border border-grey-300 text-sm ml-1 leading-5 font-medium rounded-full text-grey-700">
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4" />
                          </svg>
                        </button>
                      </ng-template>

                      <button type="button" (click)="acceptService(service, data.menuData.vehicle)"
                        [disabled]="data.disableAddServiceButton === true || acceptedAsALineItem(service?.dmsOpCodeRecord, data.selectedAppointmentCases) || declinedOnAppointment(service?.dmsOpCodeRecord, data.selectedAppointmentDeclinedOperations)"
                        [ngClass]="[checkServiceGroupStatus('declined', service?.dmsOpCodeRecord, data.hyundaiServices) ? 'invisible': '', data.disableAddServiceButton === true || acceptedAsALineItem(service?.dmsOpCodeRecord, data.selectedAppointmentCases) || declinedOnAppointment(service?.dmsOpCodeRecord, data.selectedAppointmentDeclinedOperations) ? 'bg-grey-300' : 'bg-white']"
                        *ngIf="!checkServiceGroupStatus('accepted', service?.dmsOpCodeRecord, data.hyundaiServices); else accepted"
                        class="inline-flex items-center shadow-sm px-2 py-1.5 border border-grey-300 text-sm ml-1 leading-5 font-medium rounded-full text-grey-700 bg-white">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-grey-400" fill="none"
                          viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                      </button>

                      <ng-template #accepted>
                        <button type="button"
                          [disabled]="data.disableRemoveServiceButton === true || alreadyProcessedOnWorkOrder(service?.dmsOpCodeRecord, data.acceptedServices)"
                          [ngClass]="data.disableRemoveServiceButton === true || alreadyProcessedOnWorkOrder(service?.dmsOpCodeRecord, data.acceptedServices) ? 'bg-grey-300' : 'bg-green-500'"
                          (click)="removeAcceptedService(service)"
                          class="inline-flex items-center shadow-sm px-2 py-1.5 border border-grey-300 text-sm ml-1 leading-5 font-medium rounded-full text-grey-700">
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none"
                            viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4" />
                          </svg>
                        </button>
                      </ng-template>

                    </div>
                  </div>
                </div>
                <div *ngIf="checkServiceGroupStatus('declined', service?.dmsOpCodeRecord, data.hyundaiServices)"
                  class="flex flex-col place-content-end px-2">
                  <span class="text-grey-600">Declined reason:</span>
                  <mat-form-field>
                    <mat-select
                      [(value)]="data.declinedServices.entities[service?.dmsOpCodeRecord.workOrderLocationOpCode] ? data.declinedServices.entities[service?.dmsOpCodeRecord.workOrderLocationOpCode].declinedReasonId : nextDeclinedReason"
                      (selectionChange)="declinedReasonSelected(service, $event.value)">
                      <mat-option [value]="nextDeclinedReason.id"
                        *ngFor="let nextDeclinedReason of data.declinedReasons | filterBy: ['rooftopId']: data.currentEmployee.rooftopId | orderBy: ['reason']">
                        {{nextDeclinedReason.reason}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div *ngIf="serviceDetailsToggle.value" class="flex flex-col py-1 px-3">
                  <ul class="list-disc leading-relaxed pl-1">
                    <li *ngFor="let childService of service.ChildServiceDetails | orderBy: ['DisplayOrder']"
                      class="text-grey-500">{{childService.Name}}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
      <ng-template #fullSchedule>
        <div
          class="flex flex-col border border-solid border-grey-300 divide-x divide-grey-300 rounded-lg w-full mt-5 h-auto">
          <div id="previousService" class="flex flex-col w-full py-6 px-6 border-b border-grey-400">
            <span class="flex place-content-start font-medium text-base">Previous Service</span>
            <div class="flex flex-col mt-1">
              <span
                class="flex pb-2 font-medium text-xl place-content-start">{{data?.menuData?.fullScheduleResponse?.PreviousServiceOdometer
                |
                unitOfMeasure | async }}
                Service</span>
              <span class="text-xs text-grey-600 pb-2">Includes below services:</span>
              <div *ngFor="let service of data.menuData?.fullScheduleResponse?.PreviousService; let i = index ">
                <div class="flex flex-col">
                  <div class="flex flex-row place-content-between place-items-center">
                    <div class="flex-grow flex flex-row place-content-start">
                      <span class="mr-1">·</span><span class="flex w-3/4">{{service.Name}}</span>
                    </div>
                    <div class="relative flex items-center place-content-center" value="false" #serviceDetailsToggle>
                      <span type="button" [ngClass]="{'invisible': service.ChildServiceDetails.length == 0 }"
                        (click)="serviceDetailsToggle.value = !serviceDetailsToggle.value"
                        class="inline-flex items-center shadow-sm px-4 py-1.5 border border-grey-300 text-sm leading-5 font-medium rounded-full text-grey-700 bg-white">
                        <svg *ngIf="!serviceDetailsToggle.value; else minus" class="-ml-1.5 mr-1 h-5 w-5 text-grey-600"
                          xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd"
                            d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                            clip-rule="evenodd" />
                        </svg>
                        <ng-template #minus>
                          <svg class="-ml-1.5 mr-1 h-5 w-5 text-grey-400" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z"
                              clip-rule="evenodd" />
                          </svg>
                        </ng-template>
                        <span>Details</span>
                      </span>
                    </div>
                  </div>
                  <div *ngIf="checkServiceGroupStatus('declined', service?.dmsOpCodeRecord, data.hyundaiServices)"
                    class="flex flex-col place-content-end px-2">
                    <span class="text-grey-600">Declined reason:</span>
                    <mat-form-field>
                      <mat-select
                        [(value)]="data.declinedServices.entities[service?.dmsOpCodeRecord.workOrderLocationOpCode] ? data.declinedServices.entities[service?.dmsOpCodeRecord.workOrderLocationOpCode].declinedReasonId : previousDeclinedReason"
                        (selectionChange)="declinedReasonSelected(service, $event.value)">
                        <mat-option [value]="previousDeclinedReason.id"
                          *ngFor="let previousDeclinedReason of data.declinedReasons | filterBy: ['rooftopId']: data.currentEmployee.rooftopId | orderBy: ['reason']">
                          {{previousDeclinedReason.reason}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div *ngIf="serviceDetailsToggle.value" class="flex flex-col ml-6">
                    <ul class="list-disc leading-relaxed pl-1">
                      <li *ngFor="let childService of service.ChildServiceDetails | orderBy: ['DisplayOrder']"
                        class="text-grey-500">{{childService.Name}}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="currentService" class="flex flex-col w-full py-6 px-6 border-b bg-grey-200 border-grey-400">
            <span class="flex place-content-start font-medium text-base">Current Service</span>
            <div class="flex flex-col mt-1">
              <span
                class="flex pb-2 font-medium text-xl place-content-start">{{data?.menuData?.fullScheduleResponse?.CurrentServiceOdometer
                |
                unitOfMeasure | async }}
                Service</span>
              <span class="text-xs text-grey-600 pb-2">Includes below services:</span>
              <div *ngFor="let service of data.menuData?.fullScheduleResponse?.CurrentService; let i = index ">
                <div class="flex flex-col">
                  <div class="flex flex-row place-content-between place-items-center">
                    <div class="flex-grow flex flex-row place-content-start">
                      <span class="mr-1">·</span><span class="flex w-3/4">{{service.Name}}</span>
                    </div>
                    <div class="relative flex items-center place-content-center" value="false" #serviceDetailsToggle>
                      <span type="button" [ngClass]="{'invisible': service.ChildServiceDetails.length == 0 }"
                        (click)="serviceDetailsToggle.value = !serviceDetailsToggle.value"
                        class="inline-flex items-center shadow-sm px-4 py-1.5 border border-grey-300 text-sm leading-5 font-medium rounded-full text-grey-700 bg-white">
                        <svg *ngIf="!serviceDetailsToggle.value; else minus" class="-ml-1.5 mr-1 h-5 w-5 text-grey-600"
                          xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd"
                            d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                            clip-rule="evenodd" />
                        </svg>
                        <ng-template #minus>
                          <svg class="-ml-1.5 mr-1 h-5 w-5 text-grey-400" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z"
                              clip-rule="evenodd" />
                          </svg>
                        </ng-template>
                        <span>Details</span>
                      </span>
                    </div>
                  </div>
                  <div *ngIf="checkServiceGroupStatus('declined', service?.dmsOpCodeRecord, data.hyundaiServices)"
                    class="flex flex-col place-content-end px-2">
                    <span class="text-grey-600">Declined reason:</span>
                    <mat-form-field>
                      <mat-select
                        [(value)]="data.declinedServices.entities[service?.dmsOpCodeRecord.workOrderLocationOpCode] ? data.declinedServices.entities[service?.dmsOpCodeRecord.workOrderLocationOpCode].declinedReasonId : previousDeclinedReason"
                        (selectionChange)="declinedReasonSelected(service, $event.value)">
                        <mat-option [value]="previousDeclinedReason.id"
                          *ngFor="let previousDeclinedReason of data.declinedReasons | filterBy: ['rooftopId']: data.currentEmployee.rooftopId | orderBy: ['reason']">
                          {{previousDeclinedReason.reason}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div *ngIf="serviceDetailsToggle.value" class="flex flex-col ml-6">
                    <ul class="list-disc leading-relaxed pl-1">
                      <li *ngFor="let childService of service.ChildServiceDetails | orderBy: ['DisplayOrder']"
                        class="text-grey-500">{{childService.Name}}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="nextService" class="flex flex-col w-full py-6 px-6 border-b border-grey-400">
            <span class="flex place-content-start font-medium text-base">Next Service</span>
            <div class="flex flex-col mt-1">
              <span
                class="flex pb-2 font-medium text-xl place-content-start">{{data?.menuData?.fullScheduleResponse?.NextServiceOdometer
                |
                unitOfMeasure | async }}
                Service</span>
              <span class="text-xs text-grey-600 pb-2">Includes below services:</span>
              <div *ngFor="let service of data.menuData?.fullScheduleResponse?.NextService; let i = index ">
                <div class="flex flex-col">
                  <div class="flex flex-row place-content-between place-items-center">
                    <div class="flex-grow flex flex-row place-content-start">
                      <span class="mr-1">·</span><span class="flex w-3/4">{{service.Name}}</span>
                    </div>
                    <div class="relative flex items-center place-content-center" value="false" #serviceDetailsToggle>
                      <span type="button" [ngClass]="{'invisible': service.ChildServiceDetails.length == 0 }"
                        (click)="serviceDetailsToggle.value = !serviceDetailsToggle.value"
                        class="inline-flex items-center shadow-sm px-4 py-1.5 border border-grey-300 text-sm leading-5 font-medium rounded-full text-grey-700 bg-white">
                        <svg *ngIf="!serviceDetailsToggle.value; else minus" class="-ml-1.5 mr-1 h-5 w-5 text-grey-600"
                          xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd"
                            d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                            clip-rule="evenodd" />
                        </svg>
                        <ng-template #minus>
                          <svg class="-ml-1.5 mr-1 h-5 w-5 text-grey-400" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z"
                              clip-rule="evenodd" />
                          </svg>
                        </ng-template>
                        <span>Details</span>
                      </span>
                    </div>
                  </div>
                  <div *ngIf="checkServiceGroupStatus('declined', service?.dmsOpCodeRecord, data.hyundaiServices)"
                    class="flex flex-col place-content-end px-2">
                    <span class="text-grey-600">Declined reason:</span>
                    <mat-form-field>
                      <mat-select
                        [(value)]="data.declinedServices.entities[service?.dmsOpCodeRecord.workOrderLocationOpCode] ? data.declinedServices.entities[service?.dmsOpCodeRecord.workOrderLocationOpCode].declinedReasonId : previousDeclinedReason"
                        (selectionChange)="declinedReasonSelected(service, $event.value)">
                        <mat-option [value]="previousDeclinedReason.id"
                          *ngFor="let previousDeclinedReason of data.declinedReasons | filterBy: ['rooftopId']: data.currentEmployee.rooftopId | orderBy: ['reason']">
                          {{previousDeclinedReason.reason}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div *ngIf="serviceDetailsToggle.value" class="flex flex-col ml-6">
                    <ul class="list-disc leading-relaxed pl-1">
                      <li *ngFor="let childService of service.ChildServiceDetails | orderBy: ['DisplayOrder']"
                        class="text-grey-500">{{childService.Name}}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="futureServices">
            <div *ngFor="let futureService of data.menuData?.fullScheduleResponse?.FutureService"
              class="flex flex-col w-full py-6 px-6 border-b border-grey-400">
              <div class="flex flex-col mt-1">
                <span class="flex pb-2 font-medium text-xl place-content-start">{{futureService.ServiceOdometer
                  |
                  unitOfMeasure | async }}
                  Service</span>
                <span class="text-xs text-grey-600 pb-2">Includes below services:</span>
                <div *ngFor="let service of futureService.ServiceList; let i = index ">
                  <div class="flex flex-col">
                    <div class="flex flex-row place-content-between place-items-center">
                      <div class="flex-grow flex flex-row place-content-start">
                        <span class="mr-1">·</span><span class="flex w-3/4">{{service.Name}}</span>
                      </div>
                      <div class="relative flex items-center place-content-center" value="false" #serviceDetailsToggle>
                        <span type="button" [ngClass]="{'invisible': service.ChildServiceDetails.length == 0 }"
                          (click)="serviceDetailsToggle.value = !serviceDetailsToggle.value"
                          class="inline-flex items-center shadow-sm px-4 py-1.5 border border-grey-300 text-sm leading-5 font-medium rounded-full text-grey-700 bg-white">
                          <svg *ngIf="!serviceDetailsToggle.value; else minus"
                            class="-ml-1.5 mr-1 h-5 w-5 text-grey-600" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd"
                              d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                              clip-rule="evenodd" />
                          </svg>
                          <ng-template #minus>
                            <svg class="-ml-1.5 mr-1 h-5 w-5 text-grey-400" xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20" fill="currentColor">
                              <path fill-rule="evenodd" d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z"
                                clip-rule="evenodd" />
                            </svg>
                          </ng-template>
                          <span>Details</span>
                        </span>
                      </div>
                    </div>
                    <div *ngIf="checkServiceGroupStatus('declined', service?.dmsOpCodeRecord, data.hyundaiServices)"
                      class="flex flex-col place-content-end px-2">
                      <span class="text-grey-600">Declined reason:</span>
                      <mat-form-field>
                        <mat-select
                          [(value)]="data.declinedServices.entities[service?.dmsOpCodeRecord.workOrderLocationOpCode] ? data.declinedServices.entities[service?.dmsOpCodeRecord.workOrderLocationOpCode].declinedReasonId : previousDeclinedReason"
                          (selectionChange)="declinedReasonSelected(service, $event.value)">
                          <mat-option [value]="previousDeclinedReason.id"
                            *ngFor="let previousDeclinedReason of data.declinedReasons | filterBy: ['rooftopId']: data.currentEmployee.rooftopId | orderBy: ['reason']">
                            {{previousDeclinedReason.reason}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div *ngIf="serviceDetailsToggle.value" class="flex flex-col ml-6">
                      <ul class="list-disc leading-relaxed pl-1">
                        <li *ngFor="let childService of service.ChildServiceDetails | orderBy: ['DisplayOrder']"
                          class="text-grey-500">{{childService.Name}}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </ng-template>
    </div>



    <ng-template #hyundaiMenuError>
      <div class="flex place-content-center font-medium text-lg text-red-500 w-full">
        {{data.menuData?.hyundaiResponse?.error}}
      </div>
    </ng-template>
  </div>


  <ng-template #loading>
    <div class="flex flex-row border border-solid border-grey-300 divide-x divide-grey-300 rounded-lg w-full mt-5">
      <div id="previousService" class="flex flex-col w-4/12 pt-4 px-2 divide-y divide-grey-300">
        <span class="flex place-content-center font-medium text-sm pb-3">Previous Service</span>
        <div class="flex flex-col pt-3 animated-background h-96"></div>
      </div>

      <div id="currentService" class="flex flex-col w-4/12 pt-4 px-2 divide-y divide-grey-300 bg-grey-200">
        <span class="flex place-content-center font-medium text-base pb-2">Current Service</span>
        <div class="flex flex-col pt-3 animated-background h-96"></div>
      </div>

      <div id="nextService" class="flex flex-col w-4/12 pt-4 px-2 divide-y divide-grey-300">
        <span class="flex place-content-center font-medium text-sm pb-3">Next Service</span>
        <div class="flex flex-col pt-3 animated-background h-96"></div>
      </div>
    </div>
  </ng-template>

</div>